import { Container } from "../../../components";
import { Card } from "antd";
import "./index.scss";
export var MoreTatum = function MoreTatum() {
  var gridStyle = {
    width: "100%",
    align: "center"
  };
  return /*#__PURE__*/React.createElement(Container, {
    isGridCard: true
  }, /*#__PURE__*/React.createElement(Card, {
    title: "More about Tatum"
  }, /*#__PURE__*/React.createElement(Card.Grid, {
    hoverable: false,
    style: gridStyle,
    className: "more-tatum-container"
  }, /*#__PURE__*/React.createElement("div", null, "Leverage Tatum\u2019s infrastructure, SDK, and powerful unified API to build blockchain apps quickly and easily. You don't need to worry about blockchain node configuration or maintenance, and you don't need to learn to code for individual blockchains. Code once, and deploy to any blockchain."), /*#__PURE__*/React.createElement("div", {
    className: "social-links"
  }, "Social Links"), /*#__PURE__*/React.createElement(SocLink, {
    href: "https://discord.gg/7ZKCRD5bG3",
    label: "Discord"
  }), /*#__PURE__*/React.createElement(SocLink, {
    href: "https://www.reddit.com/r/tatum_io/",
    label: "Reddit"
  }), /*#__PURE__*/React.createElement(SocLink, {
    href: "https://t.me/tatumio",
    label: "Telegram"
  }), /*#__PURE__*/React.createElement(SocLink, {
    href: "https://twitter.com/tatum_io",
    label: "Twitter"
  }), /*#__PURE__*/React.createElement(SocLink, {
    href: "https://www.youtube.com/channel/UCF-OAfXNJ9h3U2ycHE1NGNw",
    label: "Youtube"
  }), /*#__PURE__*/React.createElement(SocLink, {
    href: "https://www.linkedin.com/company/tatumio/",
    label: "LinkedIn"
  }))));
};

var SocLink = function SocLink(_ref) {
  var href = _ref.href,
      label = _ref.label;
  return /*#__PURE__*/React.createElement("div", null, /*#__PURE__*/React.createElement("a", {
    className: "soc-link",
    target: "_blank",
    rel: "noreferrer",
    href: href
  }, label));
};